exports.debugOut = async (message, source, params) => {
  const debug = source.debug;
  let out = '';
  if (debug !== undefined) {
    try {
      out += "".concat(source.type, ": \"").concat(debug, "\"\n");
      if (message !== undefined) {
        out += "".concat(message, "\n");
      }
      if (params !== undefined) {
        Object.keys(params).forEach(paramName => {
          const value = params[paramName];
          out += "".concat(paramName, " = ").concat(JSON.stringify(value, null, 2), "\n");
        });
      }
      /* eslint-disable no-console */
      console.log(out);
    } catch (e) {
      /* eslint-disable no-console */
      console.log("debug statement failed, ignoring ".concat(debug));
    }
  }
};